module.exports = __webpack_public_path__ + "static/media/Sanomat Grab Web-Medium TH.3e637c3c.woff";